import React, {useRef, useEffect} from 'react';
import styles from './Loader.module.scss';
import panelStyles from 'components/homePanels/Panels.module.scss'
import {gsap, TimelineMax, TweenMax} from "gsap";
import {useDispatch, useSelector} from "react-redux";


const Loader = (props) => {

    const loader = useRef();
    const foreGround = useRef();
    const title = useRef();
    const square1 = useRef();
    const square2 = useRef();
    const square3 = useRef();
    const square4 = useRef();
    const timeline1 = useRef();
    const timeline2 = useRef();

    const assets = useSelector(state => state.assetsLoaded);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()

    useEffect(()=>{

        if(square1.current && square2.current && square3.current && square4.current){

            timeline1.current = new TimelineMax().pause();

            let timeBox1 = new TimelineMax({ repeat: -1, repeatDelay: 1.5 })
                .to(square1.current, 0.5, {opacity: 1})
                .to(square1.current, 0.5, {opacity: 0});

            let timeBox2 = new TimelineMax({ repeat: -1, repeatDelay: 1.5, delay: .5 })
                .to(square2.current, 0.5, {opacity: 1})
                .to(square2.current, 0.5, {opacity: 0});

            let timeBox3 = new TimelineMax({ repeat: -1, repeatDelay: 1.5, delay: 1 })
                .to(square3.current, 0.5, {opacity: 1})
                .to(square3.current, 0.5, {opacity: 0});

            let timeBox4 = new TimelineMax({ repeat: -1, repeatDelay: 1.5, delay: 1.5 })
                .to(square4.current, 0.5, {opacity: 1})
                .to(square4.current, 0.5, {opacity: 0});

            timeline1.current.add([timeBox1, timeBox2, timeBox3, timeBox4]);

            timeline1.current.play();

            timeline2.current = new TimelineMax().pause();

            let fillBox1 = new TweenMax.to(square1.current, 0.5, {opacity: 1});
            let fillBox2 = new TweenMax.to(square2.current, 0.5, {opacity: 1});
            let fillBox3 = new TweenMax.to(square3.current, 0.5, {opacity: 1});
            let fillBox4 = new TweenMax.to(square4.current, 0.5, {opacity: 1});

            timeline2.current.add([fillBox1, fillBox2, fillBox3, fillBox4]);

        }

    }, [])

    useEffect(()=>{
        if(assets.assetsLoaded && !accessible.siteEntered){

            /** pause loader, fade all in **/
            setTimeout(()=>{
                timeline1.current.pause();
                timeline2.current.play();
            }, 1000)

            /** fade all out **/

            setTimeout(()=>{

                gsap.fromTo(foreGround.current,
                {transform: `perspective(100px) translateZ(0px) translateY(0px)`},
                { transform: `perspective(100px) translateZ(200px)  translateY(30px)`, duration: 2});
                gsap.to(loader.current, { delay: 0.5, opacity: 0, duration: 0.5, onComplete:()=>{
                        gsap.to(loader.current, { display:'none', duration: 0});
                    }});

            },3000)

            setTimeout(()=>{

                dispatch({ type: "SET_ACCESSIBLE",
                    payload: {
                        ...accessible,
                        siteEntered: true
                    }
                });
            }, 3500)


        }
    }, [assets.assetsLoaded, dispatch, accessible])

    useEffect(()=>{
        setTimeout(()=>{
            if(accessible.cookiesAccepted && title.current) title.current.focus()
        }, 1000)

    }, [accessible.cookiesAccepted])

    return (
        <div aria-hidden={accessible.modalOpen} ref={loader} className={`${panelStyles.fixedStage} ${styles.loader}`} style={{zIndex: props.zIndex, opacity: 1}}>
            <div className={`${panelStyles.hero}`}>
                <div ref={foreGround} className={`${panelStyles.foreGround}  ${styles.foreGround}`} style={{opacity: 1}}>
                    <div className={panelStyles.boxesLogoWrapper}>
                        <div className={`${panelStyles.boxesLogo} ${panelStyles.loader}`}>
                            <div ref={square1} className={panelStyles.square1}/>
                            <div ref={square2} className={panelStyles.square2}/>
                            <div ref={square3} className={panelStyles.square3}/>
                            <div ref={square4} className={panelStyles.square4}/>
                        </div>
                    </div>
                    <div className={panelStyles.info}>
                        <h1>Original by design</h1>
                    </div>
                </div>

            </div>


        </div>
    )
};

export default Loader